import { render, staticRenderFns } from "./SfProductOption.vue?vue&type=template&id=6a0a18d0&"
import script from "./SfProductOption.vue?vue&type=script&lang=js&"
export * from "./SfProductOption.vue?vue&type=script&lang=js&"
import style0 from "./SfProductOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports